(() => {
  function init() {
    document.querySelectorAll('.gv-promo').forEach(module => {
      if (module.dataset.gvReady) return;
      module.dataset.gvReady = 'true';
      const track = module.querySelector('.gv-promo__track');
      const cards = [...track.children];
      const buttons = [...module.querySelectorAll('[data-gv-index]')];
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      buttons.forEach((button, index) => button.addEventListener('click', () => {
        const relativeLeft = cards[index].getBoundingClientRect().left - track.getBoundingClientRect().left;
        track.scrollTo({left: track.scrollLeft + relativeLeft, behavior: reducedMotion.matches ? 'auto' : 'smooth'});
      }));
      let pending = false;
      track.addEventListener('scroll', () => {
        if (pending) return;
        pending = true;
        requestAnimationFrame(() => {
          pending = false;
          const bounds = track.getBoundingClientRect();
          let best = 0;
          let maxVisible = -1;
          cards.forEach((card, index) => {
            const rect = card.getBoundingClientRect();
            const visible = Math.max(0, Math.min(bounds.right, rect.right) - Math.max(bounds.left, rect.left));
            if (visible > maxVisible) { best = index; maxVisible = visible; }
          });
          buttons.forEach((button, index) => button.setAttribute('aria-pressed', String(index === best)));
        });
      }, {passive: true});
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();